import EvaluatorDraft from 'bundles/author-code-evaluator/models/EvaluatorDraft';
import EvaluatorTestCase from 'bundles/author-code-evaluator/models/EvaluatorTestCase';
import type {
  AuthoringEvaluatorResponse,
  Metadata,
} from 'bundles/author-code-evaluator/utils/AuthoringEvaluatorAPIUtils';

class AuthoringEvaluator {
  declare id: string;

  declare metadata: Metadata;

  declare testCases: Array<EvaluatorTestCase>;

  declare draft: EvaluatorDraft;

  static getUnversionedId(versionedId: string): string {
    const parts = versionedId.split('@');
    // @ts-expect-error TS2322 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
    return parts[0];
  }

  constructor({ id, draft, testCases, metadata }: AuthoringEvaluatorResponse) {
    this.id = id;
    this.metadata = metadata;
    this.testCases = testCases.map((testCase) => new EvaluatorTestCase(testCase));
    this.draft = new EvaluatorDraft(draft);
  }

  get versionedId(): string {
    const {
      id,
      metadata: { publishedVersion },
    } = this;
    return `${id}@${publishedVersion}`;
  }

  toJSON(): AuthoringEvaluatorResponse {
    const { id, metadata } = this;
    const draft = this.draft.toJSON();
    const testCases = this.testCases.map((testCase) => testCase.toJSON());

    return { id, draft, testCases, metadata };
  }
}

export default AuthoringEvaluator;
